import * as React from "react";
const SvgTick = props => <svg width={39} height={32} viewBox="0 0 39 32" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12.7745 31.9671L0 19.1926L5.82154 13.371L12.7745 20.3445L33.0985 0L38.92 5.82154L12.7745 31.9671Z" stroke="none" /></svg>;
export default SvgTick;